import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import ContractorModel, { CreateContractorModel, UpdateContractorModel } from "../../viewModels/Contractors/ContractorModel";

const initialState: {
  open: boolean;
  loading: boolean;
  contractor?: ContractorModel;
} = {
  open: false,
  loading: false,
};

const editContractorDrawer = createSlice({
  name: "editContractorDrawer",
  initialState,
  reducers: {
    openDrawer(state, action: PayloadAction<ContractorModel | undefined>) {
      state.open = true;
      state.contractor = action.payload;
    },
    closeDrawer(state) {
      state.open = false;
      state.contractor = undefined;
    },
    createContractor(state, _action: PayloadAction<CreateContractorModel>) {
      state.loading = true;
    },
    createContractorSuccess(state, _action: PayloadAction<ContractorModel>) {
      state.loading = false;
      state.open = false;
    },
    createContractorError(state) {
      state.loading = false;
      state.open = false;
    },

    updateContractor(state, _action: PayloadAction<UpdateContractorModel>) {
      state.loading = true;
    },
    updateContractorSuccess(state, _action: PayloadAction<ContractorModel>) {
      state.loading = false;
      state.open = false;
    },
    updateContractorError(state) {
      state.loading = false;
      state.open = false;
    },
  },
});

export default editContractorDrawer;
